import api from './client'
import type { SourceBadgeConfig } from '@/types/sourceBadge'

export function fetchSourceBadges() {
  return api.get<{ data: SourceBadgeConfig[] }>('/source_badges')
}
